import { useState } from 'react';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import { Warning } from '@phosphor-icons/react';
import { useAuth } from '../context/AuthContext';
import { resendVerificationEmail } from '../utils/emailVerification';

/* Persistent reminder rendered INSIDE the fixed header (Header.js) / the
   landing page's own nav — never mounted standalone, so it naturally sits
   above the nav row and its height is picked up by the existing
   useElementHeight spacer (no separate z-index/overlay logic needed). */
export const EmailVerificationBanner = () => {
  const { user } = useAuth();
  const { t } = useTranslation();
  const [sending, setSending] = useState(false);

  if (!user || user.email_verified !== false) {
    return null;
  }

  const handleResend = async () => {
    setSending(true);
    try {
      await resendVerificationEmail();
      toast.success(t('emailVerify.resendSuccess'));
    } catch (e) {
      toast.error(e.response?.data?.detail || t('emailVerify.resendFailed'));
    } finally {
      setSending(false);
    }
  };

  return (
    <div
      data-testid="email-verification-banner"
      className="bg-amber-50 border-b border-amber-300 text-amber-900 px-4 py-2 flex flex-wrap items-center justify-center gap-2 text-xs sm:text-sm text-center relative z-10"
    >
      <Warning size={16} weight="fill" className="text-amber-600 shrink-0" />
      <span>{t('emailVerify.bannerMessage')}</span>
      <button
        data-testid="email-verification-resend-btn"
        onClick={handleResend}
        disabled={sending}
        className="underline font-semibold hover:text-amber-700 disabled:opacity-50"
      >
        {sending ? t('common.loading') : t('emailVerify.resendButton')}
      </button>
    </div>
  );
};
